import createApiClient from './apiClient';
import { cachedRequest, invalidateCache } from '../utils/apiDataCache';

function notificationBaseUrl() {
  return (process.env.REACT_APP_ATHENIAN_STUDENT_SERVICE_URL || 'http://127.0.0.1:5001/api/students')
    .replace(/\/api\/students\/?$/, '');
}

const notificationApi = createApiClient(`${notificationBaseUrl()}/api/notifications`);

export const getNotifications = ({
  status = 'all',
  category = 'all',
  page = 1,
  limit = 20,
} = {}) =>
  cachedRequest(
    `notifications:${status}:${category}:${page}:${limit}`,
    () => notificationApi.get('', { params: { status, category, page, limit } }),
    60_000,
  );

export const getUnreadNotificationCount = () =>
  cachedRequest('notifications:unread-count', () => notificationApi.get('/unread-count'), 30_000);

export const getNotification = (id) =>
  notificationApi.get(`/${id}`);

export const markNotificationsRead = (ids) => {
  invalidateCache('notifications:');
  return notificationApi.post('/mark-read', { ids });
};

export const markNotificationsUnread = (ids) => {
  invalidateCache('notifications:');
  return notificationApi.post('/mark-unread', { ids });
};

export const starNotifications = (ids, starred = true) => {
  invalidateCache('notifications:');
  return notificationApi.post('/star', { ids, starred });
};

export const deleteNotifications = (ids) => {
  invalidateCache('notifications:');
  return notificationApi.post('/bulk-delete', { ids });
};

export const markAllNotificationsRead = (status = 'all') => {
  invalidateCache('notifications:');
  return notificationApi.post('/mark-all-read', { status });
};

export const markAllNotificationsUnread = (status = 'all') => {
  invalidateCache('notifications:');
  return notificationApi.post('/mark-all-unread', { status });
};

export const deleteAllNotifications = (status = 'all') => {
  invalidateCache('notifications:');
  return notificationApi.post('/delete-all', { status });
};
